import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Sun = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M6.76 5.29122L4.96 3.50122L3.55 4.91122L5.34 6.70122L6.76 5.29122ZM4 10.9512H1V12.9512H4V10.9512ZM13 1.00122H11V3.95122H13V1.00122ZM20.45 4.91122L19.04 3.50122L17.25 5.29122L18.66 6.70122L20.45 4.91122ZM17.24 18.6112L19.03 20.4112L20.44 19.0012L18.64 17.2112L17.24 18.6112ZM20 10.9512V12.9512H23V10.9512H20ZM12 5.95122C8.69 5.95122 6 8.64122 6 11.9512C6 15.2612 8.69 17.9512 12 17.9512C15.31 17.9512 18 15.2612 18 11.9512C18 8.64122 15.31 5.95122 12 5.95122ZM11 22.9012H13V19.9512H11V22.9012ZM3.55 18.9912L4.96 20.4012L6.75 18.6012L5.34 17.1912L3.55 18.9912Z"
    />
  </svg>
);
